(ns practitest.frontend.forms3.entity-form.testset-instances-columns
  (:require
   [practitest.frontend.components2.run-status :as run-status]))

(defn get-testset-instance-columns []
  (concat [{:type :testset-instance-id
            :field :display_id
            :systemcol? true
            :default-width 50
            :default-show? true
            :header "ID"
            :sortable? false}
           {:type :hierarchical-name
            :field :name
            :systemcol? true
            :default-width 300
            :autofilter? true
            :default-show? true
            :header "Name"
            :sortable? false}
           {:type :text
            :field :instances_count
            :systemcol? true
            :default-width 80
            :autofilter? false
            :default-show? true
            :header "Instances Count"
            :sortable? false}
           {:default-width 100
            :default-show? true
            :systemcol? true
            :field :last_run
            :type :date-time
            :header "Last Run"
            :autofilter? true
            :sortable? false}]
          [{:type :testset-instance-run-status
            :field :run_status
            :systemcol? true
            :default-width 200
            :default-show? true
            :header "Run Status"
            :autofilter? true
            :sortable? false
            :possible-values (vec (keys run-status/statuses-map))
            :multiple? true}]))
